<template>
  <div>
    <div class="feedback-wrap">
      <div class="head-topbar lite-page-top linebottom sticky">
        <div class="topbar-left" @click="goto('/jnt/help')">
          <i class="icon-arrow-left"></i>
        </div>
        <div class="topbar-main">
          <h4>{{feedlink.question}}</h4>
        </div>
      </div>
      <div class="feedback-content">{{feedlink.answer}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'view',
  data() {
    return {
      show: false,
      id: null,
      feedlink: {
        id: null,
        question: null,
        answer: null,
      }
    }
  },
  methods: {
    goto(str) {
      this.$router.push({ path: str })
    },
    queryFeedlinkOne(){
      var that=this
      this.$queryOne('MsgFeedlink', { id: this.id }, this.feedlink, function(res) {
        that.feedlink = res.data
      })
    }
  },
  mounted() {
    this.id = this.$route.params.id
    this.queryFeedlinkOne()
  },
  created() {
    this.id = this.$route.params.id
  },
  watch: {},
}
</script>

<style>
.faq-content {
  padding: 0 1.363rem;
  box-sizing: border-box;
  padding-bottom: 1.363rem;
}

.faq-content .faq-title {
  padding-top: 1.363rem;
  font-size: 1.45rem;
  color: #333;
  line-height: 1.5;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
}

.faq-content .faq-name {
  font-size: 1.272rem;
  color: #333;
  box-sizing: border-box;
  margin-top: 1.363rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
}

.head-topbar.sticky {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 100;
  width: 100%;
}
.head-topbar {
  display: flex;
  align-items: center;
  height: 3.8rem;
  background: #fff;
  position: fixed;
  width: 100%;
  z-index: 1;
}
.dashedlinebottom,
.dashedlinetop,
.linebottom,
.lineright,
.linetop {
  position: relative;
  -webkit-box-sizing: border-box;
  padding: 0;
}
.head-topbar .topbar-left {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 6.73333vw;
  position: absolute;
  left: 0.265rem;
  height: 100%;
  z-index: 10;
}

.head-topbar .topbar-left .icon-arrow-left {
  background: url(../../../assets/jnt/left1.png) no-repeat;
  background-size: 100%;
  display: inline-block;
  height: 1.363rem;
  width: 0.818rem;
}
.head-topbar .topbar-main,
.head-topbar .topbar-right {
  display: flex;
  justify-content: center;
  align-items: center;
}
.head-topbar .topbar-main {
  flex: 1;
  color: #333;
  font-size: 1.454rem;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: 100%;
  font-weight: 400;
}
.head-topbar .topbar-right {
  padding-right: 1rem;
  position: absolute;
  right: 0.265rem;
  font-size: 1.272rem;
}
.head-topbar .topbar-main,
.head-topbar .topbar-right {
  display: flex;
  justify-content: center;
  align-items: center;
}
/* .content {
  color: rgb(177, 109, 78);
  position: relative;
  padding: 0;
  text-align: center;
  font-size: 1.3rem;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 4.2rem;
  display: flex;
} */
.feedback-content {
  width: 100%;
  padding: 1.363rem;
  font-size: 1.272rem;
  color: #333;
  line-height: 1.4;
  box-sizing: border-box;
}
</style>
